module.exports = __webpack_public_path__ + "static/media/seatPremierOne_787-8.f5fe9a42.png";